.root {
  display: flex;
  margin-bottom: 16px;
}

.body {
  max-width: 80%;
  border-radius: 4px;
  padding: 8px 16px;
}

.hasFile {
  padding-top: 0;
}

.content {
  word-break: break-word;
  margin-right: 8px;
}

.themeDefault {
  background-color: #f5f5f5;
}

.themePrimary {
  background-color: #f7a707;
  color: #fff;
}

.themePrimary .time {
  color: #e0e0e0;
}

.sender {
  font-weight: 500;
  margin-bottom: 8px;
}

.left {
  justify-content: flex-start;
}

.right {
  justify-content: flex-end;
}

.time {
  text-align: right;
  color: #757575;
}

.file {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--grey-A100);
  height: 100px;
  margin: 0 -16px 8px -16px;
}

.fileIcon {
  transform: scale(2);
}
